import stIdle from './idle.component';
import navigationService from './navigation.service';
import stOrganizationChange from './organizationChange.component';
import stToolbar from './toolbar.component';

export default angular
  .module('st.Navigation', ['st.Search', 'st.Core'])
  .component('stIdle', stIdle)
  .service('navigationService', navigationService)
  .component('stOrganizationChange', stOrganizationChange)
  .component('stToolbar', stToolbar)
  .constant('NAVIGATION', {
    COOKIE: {
      CONFIG: { expires: 14, path: '/' },
      CURRENT_STATE: 'stNavCurrent',
      PREVIOUS_STATE: 'stNavPrev',
      LAST_WORKFLOW: 'stLastWorkflow'
    }
  });
